<script>
	export let data;

	import { request } from "../../../../scripts/request";

	import {
		isNewDataChanged,
		currentEntityID,
	} from "../../../../stores/variables";
	import { profileData } from "../../../../stores/data";

	if (data) {
		if (!data.newData) data.newData = [];
		if (!data.newData[data.field_name]) data.newData[data.field_name] = "";
		request
			.fetchData("domains", "domains", {}, { method: "GET" })
			.then((result) => {
				if (!Array.isArray(result)) result = Object.values(result);
				if (!data.domains) data.domains = result;
				if (!data.newData[data.field_name]) {
					if ($currentEntityID == 0 && $profileData.Domain > 0) {
						data.newData[data.field_name] = $profileData.Domain;
					} else {
						data.newData[data.field_name] = data.domains[0].ID;
					}
				}
			});
	}
</script>

{#if data}
	{#if data.domains}
		<select
			on:change={(e) => {
				data.newData[data.field_name] =
					e.target.options[e.target.selectedIndex].value;

				$isNewDataChanged = true;
			}}
		>
			{#each data.domains as domain, i}
				{#if domain}
					<option
						value={domain.ID}
						selected={data.newData[data.field_name] == domain.ID
							? "selected"
							: ""}>{domain.Name}</option
					>
				{/if}
			{/each}
		</select>
	{/if}
{/if}

<style lang="scss">
	select {
		display: flex;
		align-items: center;
		height: 44px;
		outline: 0;
		border: 1px solid var(--border-gray-1);
		color: var(--bg-black-1);
		font-size: 16px;
		line-height: 24px;
		padding: 9px 16px;
		transition: all 0.2s ease;
		border-radius: 8px;
		&:hover,
		&:focus-within,
		&:focus {
			border-color: var(--color-1);
		}
	}
</style>
